/* kc-addon.js v2 — multi add-on checkboxes with variant dropdowns.
 * Reads #kc-addon-data: [{title, variants:[{id,title,price,available}]}].
 * One checkbox per add-on product; checking one with multiple variants
 * reveals a dropdown to pick color/style. Each checked add-on is added as
 * its own cart line when the main product form submits.
 */
(function () {
  "use strict";
  if (window.__KC_ADDON__) return;
  window.__KC_ADDON__ = true;

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function boot() {
    var dataEl = document.getElementById("kc-addon-data");
    if (!dataEl) return;
    var addons;
    try { addons = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!addons || !addons.length) return;

    var form = null;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[name="id"]')) { form = forms[i]; break; }
    }
    if (!form) return;
    var submitBtn = form.querySelector('[name="add"], [type="submit"]');
    if (!submitBtn) return;

    var wrap = document.createElement("div");
    wrap.id = "kc-addon-box";
    var rows = [];

    addons.forEach(function (addon, idx) {
      var avail = addon.variants.filter(function (v) { return v.available; });
      var row = document.createElement("div");
      row.style.cssText = "margin:10px 0;padding:12px 14px;border:1px solid #d7dce6;border-radius:10px";
      var label = document.createElement("label");
      label.style.cssText = "display:flex;align-items:center;gap:10px;cursor:pointer;font-size:15px;line-height:1.3;margin:0";
      var cb = document.createElement("input");
      cb.type = "checkbox";
      cb.style.cssText = "width:20px;height:20px;flex:0 0 auto;margin:0";
      var txt = document.createElement("span");
      var prices = avail.map(function (v) { return v.price; });
      var uniq = prices.filter(function (p, i2) { return prices.indexOf(p) === i2; });
      if (!avail.length) {
        cb.disabled = true;
        row.style.opacity = "0.55";
        label.style.cursor = "default";
        txt.innerHTML = escapeHtml(addon.title) + " — currently out of stock";
      } else if (uniq.length === 1) {
        txt.innerHTML = "Add a <b>" + escapeHtml(addon.title) + "</b> (+" + escapeHtml(uniq[0]) + ")";
      } else {
        txt.innerHTML = "Add a <b>" + escapeHtml(addon.title) + "</b> (from " + escapeHtml(avail.reduce(function (a, v) { return parseFloat(v.price.replace(/[^0-9.]/g, "")) < parseFloat(a.price.replace(/[^0-9.]/g, "")) ? v : a; }).price) + ")";
      }
      label.appendChild(cb);
      label.appendChild(txt);
      row.appendChild(label);

      var sel = null;
      if (avail.length && addon.variants.length > 1) {
        sel = document.createElement("select");
        sel.style.cssText = "display:none;margin-top:10px;width:100%;padding:9px 10px;border:1px solid #cfd6e4;border-radius:8px;font-size:14px";
        addon.variants.forEach(function (v) {
          var o = document.createElement("option");
          o.value = v.id;
          o.textContent = (v.title === "Default Title" ? addon.title : v.title) + " — " + v.price + (v.available ? "" : " (out of stock)");
          if (!v.available) o.disabled = true;
          sel.appendChild(o);
        });
        var firstAvail = addon.variants.findIndex(function (v) { return v.available; });
        if (firstAvail >= 0) sel.selectedIndex = firstAvail;
        row.appendChild(sel);
        cb.addEventListener("change", function () {
          sel.style.display = cb.checked ? "block" : "none";
        });
      }
      wrap.appendChild(row);
      rows.push({ cb: cb, sel: sel, single: avail.length === 1 && addon.variants.length === 1 ? avail[0] : null, addon: addon });
    });

    submitBtn.parentNode.insertBefore(wrap, submitBtn);

    var lastAdd = 0;
    form.addEventListener("submit", function () {
      var now = Date.now();
      if (now - lastAdd < 2000) return;
      var picked = [];
      rows.forEach(function (r) {
        if (!r.cb.checked || r.cb.disabled) return;
        var id = r.sel ? Number(r.sel.value) : (r.single ? r.single.id : (r.addon.variants.filter(function (v) { return v.available; })[0] || {}).id);
        if (id) picked.push(id);
      });
      if (!picked.length) return;
      lastAdd = now;
      var qtyEl = form.querySelector('input[name="quantity"]');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      picked.forEach(function (id) {
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: id, quantity: qty }),
          keepalive: true,
        }).catch(function () { /* cart page shows the truth */ });
      });
      try { document.dispatchEvent(new CustomEvent("cart:refresh")); } catch (e) {}
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
